import { put, select, takeEvery } from 'redux-saga/effects'

import { setActiveDrawableGroup } from '../../../actions/drawable'
import { multiSelectDrawables } from '../../slices/2D'
import { selectActiveGeometryGroupId } from '../../slices/geometry'

/**
 * Closes the active material form when multi-selecting drawables
 * if a form is currently open.
 */
export function* handleClearActiveGroupOnMultiselect({ payload }: ReturnType<typeof multiSelectDrawables>) {
    // Only proceed if items were multi-selected
    if (!payload || payload.length === 0) {
        return
    }

    const activeGeometryGroupID = yield select(selectActiveGeometryGroupId)

    // If there's an active material form open, close it
    if (activeGeometryGroupID !== null) {
        yield put(setActiveDrawableGroup(null))
    }
}

export function* watchForClearActiveGroupOnMultiselect() {
    yield takeEvery(multiSelectDrawables.type, handleClearActiveGroupOnMultiselect)
}
